import { render } from "./CreateSubscription.vue?vue&type=template&id=60d5771a&scoped=true"
import script from "./CreateSubscription.vue?vue&type=script&lang=js"
export * from "./CreateSubscription.vue?vue&type=script&lang=js"

import "./CreateSubscription.vue?vue&type=style&index=0&id=60d5771a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d5771a"]])

export default __exports__